(function () {
  function enhancePolicyPage(root) {
    if (!root || root.getAttribute("data-dg-policy-ready") === "1") return;
    root.setAttribute("data-dg-policy-ready", "1");

    var content = root.querySelector("[data-dg-policy-content]");
    var progress = root.querySelector("[data-dg-policy-progress]");
    var tocWrap = root.querySelector("[data-dg-policy-toc]");
    var tocList = root.querySelector("[data-dg-policy-toc-list]");
    var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (content && tocWrap && tocList) {
      var headings = content.querySelectorAll("h2");
      if (headings.length >= 2) {
        tocList.innerHTML = "";
        var links = [];
        headings.forEach(function (heading, index) {
          if (!heading.id) {
            heading.id =
              "policy-section-" +
              (heading.textContent || "section")
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, "-")
                .replace(/(^-|-$)/g, "") +
              "-" +
              index;
          }
          var li = document.createElement("li");
          var a = document.createElement("a");
          a.href = "#" + heading.id;
          a.className = "dg-policies__toc-link";
          a.textContent = heading.textContent.trim();
          li.appendChild(a);
          tocList.appendChild(li);
          links.push({ id: heading.id, el: a });
        });
        tocWrap.hidden = false;

        tocList.addEventListener("click", function (event) {
          var link = event.target.closest("a");
          if (!link || !tocList.contains(link)) return;
          var id = link.getAttribute("href").slice(1);
          var target = document.getElementById(id);
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: reducedMotion ? "auto" : "smooth", block: "start" });
          history.replaceState(null, "", "#" + id);
        });

        if ("IntersectionObserver" in window) {
          var observer = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                links.forEach(function (item) {
                  item.el.classList.toggle("is-active", item.id === entry.target.id);
                });
              });
            },
            { rootMargin: "-20% 0px -65% 0px", threshold: 0 }
          );
          headings.forEach(function (heading) {
            observer.observe(heading);
          });
        }
      }
    }

    if (progress && content) {
      var ticking = false;
      function updateProgress() {
        ticking = false;
        var rect = content.getBoundingClientRect();
        var total = content.offsetHeight - window.innerHeight;
        var scrolled = Math.min(Math.max(-rect.top, 0), Math.max(total, 1));
        var pct = total > 0 ? (scrolled / total) * 100 : 100;
        progress.style.width = pct + "%";
      }
      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateProgress);
      }
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll);
      updateProgress();
    }

    if (window.CraftedMotion && typeof window.CraftedMotion.init === "function") {
      window.CraftedMotion.init();
    }
  }

  function buildFromShopifyDefault() {
    var container = document.querySelector(".shopify-policy__container");
    if (!container || document.getElementById("dg-policy-page")) return;

    var titleEl = container.querySelector(".shopify-policy__title h1, .shopify-policy__title");
    var bodyEl = container.querySelector(".shopify-policy__body");
    if (!titleEl || !bodyEl) return;

    var title = titleEl.textContent.trim();
    var currentPath = window.location.pathname;
    var policyLinks = [
      { href: "/policies/privacy-policy", label: "Privacy policy" },
      { href: "/policies/refund-policy", label: "Refund policy" },
      { href: "/policies/shipping-policy", label: "Shipping policy" },
      { href: "/policies/terms-of-service", label: "Terms of service" },
    ];

    var navItems = policyLinks
      .map(function (link) {
        var active = currentPath === link.href ? " is-active" : "";
        var aria = currentPath === link.href ? ' aria-current="page"' : "";
        return (
          '<li><a href="' +
          link.href +
          '" class="dg-policies__nav-link' +
          active +
          '"' +
          aria +
          ">" +
          link.label +
          "</a></li>"
        );
      })
      .join("");

    var wrapper = document.createElement("section");
    wrapper.className = "dg-policies";
    wrapper.id = "dg-policy-page";
    wrapper.setAttribute("data-dg-policy", "");
    wrapper.innerHTML =
      '<div class="dg-policies__progress" aria-hidden="true"><span class="dg-policies__progress-bar" data-dg-policy-progress></span></div>' +
      '<div class="dg-policies__hero reveal reveal--up"><div class="dg-policies__hero-inner">' +
      '<p class="eyebrow">Legal</p><h1 class="display"></h1>' +
      '<p class="dg-policies__subhead">Clear policies for privacy, shipping, refunds, and how we stand behind Crafted Beards.</p>' +
      "</div></div>" +
      '<div class="dg-policies__trust reveal reveal--up" role="list" aria-label="Store highlights">' +
      '<span class="dg-policies__trust-item" role="listitem"><strong>Free U.S. shipping</strong> on orders over $20</span>' +
      '<span class="dg-policies__trust-item" role="listitem"><strong>6-month</strong> growth guarantee</span>' +
      '<span class="dg-policies__trust-item" role="listitem"><strong>30-day</strong> unopened returns</span>' +
      '<span class="dg-policies__trust-item" role="listitem"><strong>Crafted Beards</strong> support</span>' +
      "</div>" +
      '<div class="dg-policies__body"><div class="dg-policies__layout">' +
      '<aside class="dg-policies__nav reveal reveal--left" aria-label="Policy navigation">' +
      '<p class="dg-policies__nav-label">All Policies</p><ul class="dg-policies__nav-list">' +
      navItems +
      "</ul>" +
      '<div class="dg-policies__toc glass" data-dg-policy-toc hidden><p class="dg-policies__nav-label">On this page</p><ul class="dg-policies__toc-list" data-dg-policy-toc-list></ul></div>' +
      '<div class="dg-policies__help glass glow-target"><p class="dg-policies__help-title">Need help?</p>' +
      '<p class="dg-policies__help-text">Questions about an order, a refund, or how we handle your data? We are here.</p>' +
      '<a href="/pages/contact-us" class="dg-policies__help-link">Contact support →</a></div></aside>' +
      '<article class="dg-policies__article glass reveal reveal--up"><div class="dg-policies__content rte" data-dg-policy-content></div></article>' +
      "</div>" +
      '<div class="dg-policies__bottom-cta glass reveal reveal--up"><p>Ready for a better beard routine? Explore our growth and care essentials.</p>' +
      '<a href="/collections/beard-growth" class="dg-policies__bottom-link">Shop Beard Growth →</a></div></div>';

    container.replaceWith(wrapper);
    wrapper.querySelector(".display").textContent = title;
    wrapper.querySelector("[data-dg-policy-content]").appendChild(bodyEl);
    enhancePolicyPage(wrapper);
  }

  function boot() {
    var root = document.getElementById("dg-policy-page");
    if (root) {
      enhancePolicyPage(root);
      return;
    }
    buildFromShopifyDefault();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
